import { ProgressbarModule } from "./../progressbar/progressbar.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IconModule } from "../icon/icon.module";
import { ButtonModule } from "../button/button.module";
import { UploaderComponent } from "./uploader.component";
import { LabelModule } from "../label/label.module";
import { HelpTextModule } from "../help-text/help-text.module";
import { StatusModule } from "../status/status.module";

@NgModule({
	declarations: [UploaderComponent],
	imports: [
		CommonModule,
		IconModule,
		ButtonModule,
		FormsModule,
		LabelModule,
		HelpTextModule,
		StatusModule,
		ProgressbarModule
	],
	exports: [UploaderComponent]
})
export class UploaderModule {}
